import React, { useState, useEffect } from "react";
// import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import {
  quick_quotes,
  QuickQuote_Post,
  Err_quotes,
} from "../../Redux/actions/NumCaration";
import axiosInCar from "../../Redux/axios/AxiosInCar";
import { PreviousinsurerCar } from "../../Redux/actions/NumCaration";
// import axios from "axios";
import {
  Button,
  Form,
  DatePicker,
  Radio,
  Select,
  Row,
  Col,
  message,
} from "antd/lib";
import moment from "moment";

export default function CarRegdateupdate({ setisModalReg }) {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state?.cardetail?.carnum);
  const QuickQuotes = useSelector((state) => state.cardetail.quickquotes);
  console.log("QuickQuotes", QuickQuotes);
  const QuickQuotePost = useSelector((state) => state.cardetail.quickQuotePost);
  console.log(QuickQuotePost);
  const [QuotePost, setQuotePost] = useState(QuickQuotePost);
  const [loading, setLoading] = useState(false);
  const [preInsurer, setpreInsurer] = useState([]);
  useEffect(() => {
    dispatch(PreviousinsurerCar()).then((res) => {
      console.log(res);
      setpreInsurer(res);
    });
  }, []);
  const onFinish = (data) => {
    console.log("product data", data);
    // console.log("dateString",data.registrationDate)
    const updatedQuotePost = {
      ...QuotePost,
      registrationDate: moment(data.registrationDate).format("YYYY-MM-DD"),
      policyHolderType: data.vechicleOwned,
      previousInsurerCode: data.customertype,
    };
    console.log(updatedQuotePost);
    setLoading(true);
    axiosInCar
      .post(
        `v2/car_insurances/${auth?.car_insurance_id}/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          //console.log("data-----------------",data)
          const errData = data?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(Err_quotes(errData));
          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
          }));
          dispatch(quick_quotes(updatedData));
          //console.log(data)
          //dispatch(quick_quotes_Bike(data));
          dispatch(QuickQuote_Post(updatedQuotePost));
          setLoading(false);
          setisModalReg(false);
          // } else {
          // setLoading(false)
          // message.error(res.data.error.validationMessages.join(","));
          // }
        }
      })
      .catch((err) => {
        console.log(err.response.data.error);
        setLoading(false);
        message.error(err.response.data.error);
      });
  };
  return (
    <>
      <Form onFinish={onFinish} requiredMark={false} layout="vertical">
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              // className="form-item-bg"
              name="registrationDate"
              label="Registration Year"
              rules={[
                {
                  required: true,
                  message: "Please select Year",
                },
              ]}
              initialValue={moment(QuotePost.registrationDate)}
            >
              <DatePicker
                style={{ width: "100%" }}
                // disabledDate={disabledDate}
                // onChange={handleDateChange}
                format="YYYY-MM-DD"
                placeholder="Select Registration Year"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              // className="form-item-bg"
              name="vechicleOwned"
              label="Owner Type"
              rules={[
                {
                  required: true,
                  message: "Please select",
                },
              ]}
              initialValue={QuotePost?.policyHolderType}
            >
              <Radio.Group
                className="py-3 px-3 bg-white ant-radio-layout"
                style={{
                  width: "100%",
                }}
              >
                <Radio value="INDIVIDUAL">Individual</Radio>
                <Radio value="ORGANISATION">Organisation</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              // className="form-item-bg"
              label="previous insurer"
              name="customertype"
              rules={[
                {
                  required: true,
                  message: "Please select previous insurer",
                },
              ]}
              initialValue={QuotePost?.previousInsurerCode}
            >
              <Select
                defaultValue="Select your option"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                // onChange={handleChange}
                options={preInsurer?.map((p) => ({
                  key: p.id,
                  value: p.code,
                  label: p.name,
                }))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            loading={loading}
            htmlType="submit"
            className="update-qut-button"
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
